var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnologyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-process 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 2.625L17.625 8H13.9062C13.4375 5.72656 11.4062 4 9 4C6.25 4 4 6.25 4 9C4 11.4062 5.72656 13.4375 8 13.9062V18H4V28H14V18H10V13.9062C11.9492 13.5039 13.5039 11.9492 13.9062 10H17.5L22 14.5V18.0938C19.7266 18.5625 18 20.5938 18 23C18 25.75 20.25 28 23 28C25.75 28 28 25.75 28 23C28 20.5938 26.2734 18.5625 24 18.0938V14.5L29.4375 9.0625L23 2.625ZM23 5.46875L26.5938 9.0625L23 12.6562L19.4062 9.0625L23 5.46875ZM9 6C10.668 6 12 7.33203 12 9C12 10.668 10.668 12 9 12C7.33203 12 6 10.668 6 9C6 7.33203 7.33203 6 9 6ZM6 20H12V26H6V20ZM23 20C24.668 20 26 21.332 26 23C26 24.668 24.668 26 23 26C21.332 26 20 24.668 20 23C20 21.332 21.332 20 23 20Z",
    fill: "#005BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyIcon);
export default __webpack_public_path__ + "static/media/technologyIcon.04185644f3b65eddee6a8ad455c8cbb1.svg";
export { ForwardRef as ReactComponent };